import React, { useState } from 'react';
import {
  View, Text, FlatList, TouchableOpacity,
  StyleSheet, ActivityIndicator,
} from 'react-native';
import type { NativeStackScreenProps } from '@react-navigation/native-stack';
import type { RunStackParamList } from '../../navigation/AppNavigator';
import { usePresetRunsStore } from '../../store';

type Props = NativeStackScreenProps<RunStackParamList, 'StartRun'>;

export default function StartRunScreen({ navigation }: Props) {
  const { presetRuns, publicPresetRuns } = usePresetRunsStore();
  const all = [
    ...presetRuns.map((r) => ({ ...r, _isMine: true })),
    ...publicPresetRuns
      .filter((r) => !presetRuns.find((m) => m.presetRunId === r.presetRunId))
      .map((r) => ({ ...r, _isMine: false })),
  ];

  return (
    <View style={styles.container}>
      <Text style={styles.heading}>Choose a Preset Run</Text>
      <FlatList
        data={all}
        keyExtractor={(i) => i.presetRunId}
        ListEmptyComponent={<Text style={styles.empty}>No preset runs available.</Text>}
        renderItem={({ item }) => (
          <TouchableOpacity
            style={styles.item}
            onPress={() => navigation.navigate('ActiveRun', { mode: 'preset', presetRunId: item.presetRunId })}
          >
            <Text style={styles.name}>{item.name}</Text>
            <Text style={styles.meta}>
              {item.landmarkIds.length} landmarks · {item._isMine ? 'My run' : 'Community'}
            </Text>
          </TouchableOpacity>
        )}
        ItemSeparatorComponent={() => <View style={styles.sep} />}
      />
      <TouchableOpacity
        style={styles.createButton}
        onPress={() => navigation.navigate('CreatePresetRun')}
      >
        <Text style={styles.createText}>+ Create New Preset Run</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, backgroundColor: '#fff' },
  heading: { fontSize: 18, fontWeight: '700', padding: 16, borderBottomWidth: 1, borderColor: '#eee' },
  item: { padding: 16 },
  name: { fontSize: 15, fontWeight: '600' },
  meta: { fontSize: 12, color: '#888', marginTop: 2 },
  sep: { height: 1, backgroundColor: '#f0f0f0' },
  empty: { textAlign: 'center', color: '#aaa', marginTop: 40 },
  createButton: { margin: 16, padding: 14, backgroundColor: '#1a73e8', borderRadius: 8, alignItems: 'center' },
  createText: { color: '#fff', fontWeight: '600', fontSize: 15 },
});
